import Vue from 'vue'
import App from './App.vue'
import createRouter from '@/router'
import vuetify from '@/plugins/vuetify'
import HttpClient from '@/utils/HttpClient'
import Api from '@/services/Api'
import createStore from '@/store'
import settings from '@/settings'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import zoomingInit from 'highcharts/modules/mouse-wheel-zoom'
import day from 'dayjs'
import 'dayjs/locale/ru'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

import {LCircle, LIcon, LImageOverlay, LMap, LMarker, LTooltip} from 'vue2-leaflet'

import 'leaflet/dist/leaflet.css'
import 'vue2-datepicker/index.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/app.css'

import 'vue2-datepicker/locale/ru'

Vue.config.productionTip = false
Vue.config.devtools = true

zoomingInit(Highcharts)
Vue.use(HighchartsVue)
Highcharts.setOptions({
    lang: {
        loading: 'Загрузка...',
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        shortMonths: ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
    },
})

Vue.component('l-map', LMap)
Vue.component('l-image-overlay', LImageOverlay)
Vue.component('l-marker', LMarker)
Vue.component('l-icon', LIcon)
Vue.component('l-tooltip', LTooltip)
Vue.component('l-circle', LCircle)

day.extend(utc)
day.locale('ru')
day.extend(relativeTime)

const httpClient = new HttpClient('/api')
const api = new Api(httpClient)

const store = createStore(api)
const userString = localStorage.getItem('user')
if (userString) {
    store.commit('setUser', JSON.parse(userString))
}
const settingsString = localStorage.getItem('settings')
if (settingsString) {
    store.commit('setSettings', JSON.parse(settingsString))
}


const router = createRouter(store)

api.setUnauthorizedHandler(async () => {
    store.commit('resetUser')
    await router.push('/log-in')
})

new Vue({
    router,
    store,
    vuetify,
    provide: {
        api,
        settings,
    },
    render: h => h(App),
}).$mount('#app')
